import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/vacancies/vacancyDetail.tsx");
